import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import ipcLogoRed from '../../assets/Ipc_logo_red.svg';
import ipcLogoExtended from '../../assets/ipc_logo_extended.svg';
import ipcLogoRedWithoutText from '../../assets/LOGO_IPC_RED IPC.svg';
import LOGO_IPC_WHITE_International from '../../assets/LOGO_IPC_WHITE_International.svg';
import { httpOnlySecurityService } from '../../application/iam';
import { useUser } from '../../hooks/useUser';
import { isPublicRoute } from '../../common/utils/routeUtils';

const LeftHeader: React.FC = () => {
  const { } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isPublic = isPublicRoute(location.pathname);
  
  // Read user data from cache only - UserInformationProvider handles fetching
  // This prevents duplicate requests - we only read from React Query cache
  const { data: userInfo } = useUser(false);
  
  // Determine authentication status: 
  // Priority: userInfo > route check > token check
  const isAuthenticated = useMemo(() => {
    // If we have userInfo, user is definitely authenticated
    if (userInfo && userInfo.username) return true;
    // If we're on a protected route (not public), user must be authenticated
    // ProtectedRoute component ensures only authenticated users can access these routes
    if (!isPublic) return true;
    // If on public route, check token validity
    return false;
  }, [isPublic, userInfo]);

  const handleLogoClick = () => {
    // If we're on a protected route (not public), always navigate to /home
    // ProtectedRoute ensures only authenticated users can access these routes
    if (!isPublic) {
      navigate('/home');
      return;
    }
    
    // If on public route, check authentication status
    if (isAuthenticated) {
      navigate('/home');
    } else {
      navigate('/');
    }
  };

  return (
    <div 
      className="flex flex-nowrap items-center overflow-hidden w-full md:w-1/3"
      data-testid="left-header-container"
    >
      <div 
        className="h-[70px] flex items-center bg-red"
        data-testid="left-header-logo-container"
      >
        <img 
          className="h-full w-auto object-contain cursor-pointer" 
          src={ipcLogoRed} 
          alt="IPC logo" 
          onClick={handleLogoClick}
          data-testid="left-header-logo"
        />
      </div>
      <div 
        className="ml-7 flex items-center"
        data-testid="left-header-extended-logo-container"
      >
        <img 
          className="h-[56px] w-auto object-contain" 
          src={LOGO_IPC_WHITE_International} 
          alt="IPC extended logo"
          data-testid="left-header-extended-logo"
        />
      </div>
    </div>
  );
};

export default LeftHeader;
